
import { Component, Vue, VModel, Prop } from "vue-property-decorator";

import PazLoader from "@pazion/pazion-core/src/components/utils/PazLoader.vue";

import type { IFulfilment } from "@pazion/pazion-catalog/src/models/fulfilment";
import { b64toBlob } from "@pazion/pazion-core/src/helpers/Helper";
import { getFileContent } from "@pazion/pazion-catalog/src/services/base-service";

import fileSaver from "file-saver";

@Component({
  components: {
    PazLoader,
  },
})
export default class PazDocumentsDialog extends Vue {
  @Prop() item!: IFulfilment;
  @Prop() canShowBatch!: boolean
  @Prop( {default: "Shipment Files"}) title!: string;
  @Prop() filesList!: any[]

  @VModel({
    default: false,
  })
  public showShipmentFilesModal!: boolean;

  public tableHeadings = [
    { title: "Label", class: "text-left col-lg-3 col-6" },
    { title: "Type", class: "text-left col-lg-3 col-6" },
    { title: "File", class: "text-left col-lg-4 col-6" },
    { title: "Actions", class: "text-lg-right text-left col-lg-2 col-6" },
  ];

  async getFileData(hash: string) {
    if (!hash) return;
    const file = await getFileContent(hash);
    //TODO extend and make more dynamic
    var fileType = "application/pdf";
    if( file.extension == 'csv' ){
      fileType = "text/csv"
    }
    const fileURL = window.URL.createObjectURL(b64toBlob(file.fileData, fileType));
    fileSaver.saveAs(fileURL, file.filename);
  }
}
